/* eslint-disable arrow-body-style */
import axios from 'axios';
import React from 'react';
import {HOST_API} from '../config';
import {snackActions} from "../components/notistack/SnackbarUtilsConfigurator";

const language = localStorage.getItem('i18nextLng') || 'fa';
let errorRequest = '';
const Headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Accept-Language': `${language}`,
};

const axiosInstance = axios.create({
    baseURL: HOST_API,
    headers: Headers,
});

export const configAxios = (logout) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            // These requests display their own field-specific errors; retain the session-expiry flow.
            if (error?.config?.skipErrorNotification && error?.response?.status !== 401) {
                return Promise.reject(error);
            }
            switch (error?.response?.status) {
                case 401:
                    logout();
                    break;
                case 403:
                    snackActions.error('شما دسترسی این عملیات را ندارید.')
                    break;
            }
            if ((errorRequest !== error?.request && error?.response?.data) || error?.response?.data?.message) {
                let error_msg = '';
                switch (error?.response?.status) {
                    case 422:
                        Object.keys(error?.response?.data?.errors).map(key => {
                            error?.response?.data?.errors[key].map(item => error_msg += `${item} \n`)
                        })
                        break;
                    // case 403:
                    //     Object.keys(error?.response?.data?.errors).map(key => {
                    //         error?.response?.data?.errors[key].map(item => error_msg += `${item} \n`)
                    //     })
                    //     break;
                    default:
                        error_msg = error?.response?.data?.message
                        break;
                }
                snackActions.error(error_msg);
                errorRequest = error?.request;
            }
            return Promise.reject(error);
        }
    );
}

export default axiosInstance;
